'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

var _polished = require('polished');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  position: 'relative',
  ':after': {
    bottom: 0,
    backgroundColor: 'black',
    content: '""',
    display: 'block',
    height: '2px',
    left: 0,
    marginLeft: '50%',
    position: 'absolute',
    transition: 'all .2s ease-in-out',
    width: '0%'
  },
  '& input': {
    border: '1px solid black',
    borderRadius: 0,
    height: '36px',
    minWidth: '166px',
    outline: 'none',
    padding: '8px',
    width: '100%'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(props, theme) {
  return (0, _extends3.default)({
    '& input': {
      border: '1px solid ' + theme.colors.primaryLight,
      color: theme.colors.primaryLight,
      fontFamily: theme.font.baseFamily,
      fontSize: theme.font.baseSize,
      '::placeholder': {
        color: (0, _polished.lighten)(0.3, theme.colors.primaryLight),
        fontWeight: 'bold'
      }
    },
    ':after': {
      backgroundColor: props.error ? theme.colors.error : theme.colors.success,
      marginLeft: props.error || props.focused ? '0%' : '50%',
      width: props.error || props.focused ? '100%' : '0%'
    }
  }, (0, _objectResolvePath2.default)(theme, 'Input.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Input/Input.style.js
// module id = 525
// module chunks = 0